import CustomImage from '../../fragments/custom-image/CustomImage';
import Cta from '../../fragments/cta/Cta';
import ComponentWrapper from '../../fragments/component-wrapper/ComponentWrapper';
import ComponentHeading from '../../fragments/heading/ComponentHeading';
import RichText from '../../fragments/rich-text/RichText';

export default function ContentTwoImage({ block, index }) {
  if (!block) return null;

  const HeadingTag = index === 0 ? 'h1' : 'h2';

  return (
    <ComponentWrapper
      block={block}
      className={`ContentTwoImage image--${block.imageAlign}`}
    >
      {(block.largeHeading || block.smallHeading) && (
        <div className={'l-grid'}>
          <ComponentHeading
            heading={block.largeHeading}
            subheading={block.smallHeading}
            // cta={block.cta}
          />
        </div>
      )}
      <div className={'l-grid'}>
        <div
          className={`l-grid__col l-grid__col--m-5-12 ${block.imageAlign == 'right' ? 'l-grid__col--m-push-2-12' : ''}`}
        >
          <div className="ContentTwoImage-media">
            {block.image && (
              <CustomImage
                image={block.image}
                fill={true}
                parallax
                desktopWidth={50}
              />
            )}
          </div>
        </div>
        <div
          className={
            block.imageAlign == 'left'
              ? 'l-grid__col l-grid__col--m-6-12 l-grid__col--m-push-1-12'
              : 'l-grid__col l-grid__col--m-5-12'
          }
        >
          <div className="ContentTwoImage-text">
            <div className="ContentTwoImage-textInner">
              {block.heading && (
                <HeadingTag
                  className={`ContentTwoImage-heading h5`}
                  dangerouslySetInnerHTML={{ __html: block.heading }}
                />
              )}
              {block.content && (
                <RichText
                  className="ContentTwoImage-content"
                  html={block.content}
                />
              )}
              {block.cta && (
                <div className="ContentTwoImage-cta">
                  <Cta cta={block.cta} />
                </div>
              )}
            </div>
            <div className="ContentTwoImage-mediaSecondary">
              {block.imageSecondary && (
                <CustomImage
                  image={block.imageSecondary}
                  fill={true}
                  parallax
                  desktopWidth={33}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </ComponentWrapper>
  );
}
